(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-list-template"]) return;
  try {
    

 $(document).ready(function () {
	attachClickEvent();
  });
  
  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute() {
	pInfScrNode = $('.more').last();	
	pInfScrURL = $('.more a').last().attr("href");
	if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
		$.ajax({
			type: 'GET',
			url: pInfScrURL,
			beforeSend: function() {
			  pInfScrLoading = true;
			  pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
			  pInfScrNode.hide();
			},
			success: function(data) {
				// remove loading feedback
				pInfScrNode.next().remove();
				pInfScrNode.remove();
				var filteredData = $(data).find(".collection-matrix");
				filteredData.insertBefore( $("#product-list-foot") );					
				pInfScrLoading = false;
				/*$('li.singleproduct').setAllToMaxHeight();*/
				attachClickEvent();
			},
			dataType: "html"
		});

	}
}

function attachClickEvent(){
	$('li.more a').click(function(event){
		pInfScrExecute();
		event.stopPropagation();
		return false;
	});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    

  $(document).ready(function () {
  	attachClickEvent();
  });

  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute() {
	pInfScrNode = $('.more').last();	
	pInfScrURL = $('.more a').last().attr("href");
	if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
		$.ajax({
			type: 'GET',
			url: pInfScrURL,
			beforeSend: function() {
			  pInfScrLoading = true;
			  pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
			  pInfScrNode.hide();
			},
			success: function(data) {
				// remove loading feedback
				pInfScrNode.next().remove();
				pInfScrNode.remove();
				var filteredData = $(data).find(".collection-matrix");
				filteredData.insertBefore( $("#product-list-foot") );					
				pInfScrLoading = false;
				/*$('li.singleproduct').setAllToMaxHeight();*/
				attachClickEvent();
			},
			dataType: "html"
		});

	}
}

function attachClickEvent(){
	$('li.more a').click(function(event){
		pInfScrExecute();
		event.stopPropagation();
		return false;
	});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-and-side-help-sec"]) return;
  try {
    
 $(document).ready(function() {
    $('[data-behavior=accordion]').simpleAccordion({cbOpen:accOpen, cbClose:accClose});
    });


    function accClose(e, $this) {
    $this.find('span').fadeIn(800);
    }

    function accOpen(e, $this) {
    $this.find('span').fadeOut(800)
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    


// This button will increment the value
$('.btn.plus').click(function (e) {

  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  fieldName = $(this).attr('field');
  // Get its current value
  var currentVal = parseInt($('input[name=' + fieldName + ']').val());
  // If is not undefined
  if (!isNaN(currentVal)) {
    // Increment
    $('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    // Otherwise put a 0 there
    $('input[name=' + fieldName + ']').val(1);
  }
});
// This button will decrement the value till 0
$(".btn.minus").click(function (e) {

  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  fieldName = $(this).attr('field');
  // Get its current value
  var currentVal = parseInt($('input[name=' + fieldName + ']').val());
  // If it isn't undefined or its greater than 0
  if (!isNaN(currentVal) && currentVal > 1) {
    // Decrement one
    $('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    // Otherwise put a 0 there
    $('input[name=' + fieldName + ']').val(1);
  }
});

/*---------------- Shop Slider ------------------*/

  $('.shop-slider').bxSlider({
    pagerCustom: '#shop-slider-nav',
    mode: 'vertical',
    controls: false
  });

  $('#shop-slider-nav').bxSlider({
    slideWidth: 122,
    minSlides: 3,
    maxSlides: 5,
    mode: 'vertical',
    controls: true,
    slideMargin: 10,
    infiniteLoop: false
  });


  } catch(e) { console.error(e); }
})();

})();
